import { Component, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgxMatInputTelComponent } from 'ngx-mat-input-tel';
import { validPhoneNumberValidator } from '../../../../../../../../utils/utils';
import { LocalCsvService } from '../../../../../../../services/local-csv/local-csv.service';
import { ModalFormContainerComponent } from '../../../../../../ui/modal-form-container/modal-form-container.component';
import { InputFieldComponent } from '../../../../../../ui/inputField/inputField.component';
import { ToastService } from '../../../../../../../services/toast/toast.service';
import { formatCount } from '../../../../../../../../utils/sms';

@Component({
  selector: 'csv-phone-invalids',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    NgxMatInputTelComponent,
    ModalFormContainerComponent,
    InputFieldComponent,
  ],
  templateUrl: './invalids.component.html',
  styleUrl: './invalids.component.css',
})
export class InvalidsComponent {
  constructor(private builder: FormBuilder) {}

  localCSVService = inject(LocalCsvService);
  private toast = inject(ToastService);

  get invalids() {
    return this.localCSVService.getInvalids;
  }

  // modal state
  showUpdateModal = false;
  phoneNumberSubmitted = false;
  selectedEntry: { phoneNumber: string; id: string } | null = null;

  phoneNumberForm = this.builder.group({
    phoneNumber: ['', [Validators.required, validPhoneNumberValidator]],
  });

  openUpdateModal(entry: { phoneNumber: string; id: string }) {
    this.selectedEntry = entry;
    this.phoneNumberForm.reset({ phoneNumber: entry.phoneNumber });
    this.phoneNumberSubmitted = false;
    this.showUpdateModal = true;
  }

  closeUpdateModal() {
    this.showUpdateModal = false;
  }

  // feedback state
  feedbackMessage = '';
  /** The last "still not valid" toast, cleared once a correction works. */
  private errorToastId = 0;

  downloadInvalids() {
    const count = this.localCSVService.downloadInvalids();
    if (count) {
      this.toast.success(
        count === 1
          ? 'Downloaded 1 invalid number. Fix it, then upload the file again.'
          : `Downloaded ${formatCount(count)} invalid numbers. Fix them, then upload the file again.`
      );
    }
  }

  updatePhoneNumber() {
    this.phoneNumberSubmitted = true;
    if (!this.phoneNumberForm.valid || !this.selectedEntry) return;

    const newNumber = this.phoneNumberForm.value.phoneNumber!;
    const isNowValid = this.localCSVService.updateAndRevalidateEntry(
      this.selectedEntry.id,
      newNumber
    );

    if (this.errorToastId) this.toast.dismiss(this.errorToastId);
    this.errorToastId = 0;
    if (isNowValid) {
      this.feedbackMessage = `${newNumber} is valid now and will be added.`;
      this.toast.success(this.feedbackMessage);
    } else {
      this.errorToastId = this.toast.error(
        `${newNumber} is still not a valid number. Check the country code and try again.`
      );
    }

    this.phoneNumberForm.reset({ phoneNumber: ' ' });
    this.phoneNumberSubmitted = false;
    this.closeUpdateModal();
  }
}
